import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { compose } from 'redux';
import Select from 'react-select';

import ModalComponent from '../ModalComponent';
import { fields as saFieldsDuck, flashMessages, modals, ssatbFields as ssatbFieldsDuck } from '../../ducks/index';
import { duckify, filterDuck } from "../../utils/duckify";
import Placeholder from '../Placeholder';
import FlashRoot from 'components/FlashMessage/FlashRoot';

import './styles/SsatbFieldEditor.scss';

const SsatbFieldEditor = ({
  dispatch,
  ssatbFields,
  saFields,
  allDucksReady
}) => {
  if (!allDucksReady) {
    return <ModalComponent><Placeholder.loading /></ModalComponent>;
  }

  const [fields, setFields] = useState(ssatbFields);

  const onSubmit = () => {
    dispatch(ssatbFieldsDuck.actions.save(fields))
      .then(() => {
        dispatch(ssatbFieldsDuck.actions.markDirty()).then(() => {
          dispatch(modals.actions.hide());
        });
      })
      .catch((response) => dispatch(flashMessages.actions.show({
        message: response.errors,
        type: 'danger',
        dismissible: true
      })));
  };

  const handleChange = (obj, index) => {
    if (obj) {
      fields[index].sa_field_name = obj.value;
    } else {
      fields[index].sa_field_name = null;
    }
    setFields([...fields]);
  };

  return (
    <ModalComponent
      buttons={[<Button className='btn btn-primary' onClick={onSubmit}>Submit</Button>]}
      title="Ssatb Field Mapping"
    >
      <FlashRoot />
      <table className='table'>
        <thead>
          <tr>
            <th>SAO Field</th>
            <th>Associated Finalsite Enrollment Field</th>
          </tr>
        </thead>
        <tbody>
          {
            fields.length > 0 ? (
              fields.map((field, index) => (
                <tr key={field.sao_field_name}>
                  <td className={'ssatb-field'}>{field.sao_field_name}</td>
                  <td className={'ssatb-field'}>
                    <Select
                      options={saFields.map((saField) => ({ label: saField.name, value: saField.name }))}
                      value={field.sa_field_name}
                      className={'ssatb-field-select'}
                      onChange={(e) => handleChange(e, index)}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan='2'>
                  There are no SSATB fields present.
                </td>
              </tr>
            )

          }
        </tbody>
      </table>
    </ModalComponent>
  );
};

SsatbFieldEditor.propTypes = {
  dispatch: PropTypes.func,
  ssatbFields: PropTypes.arrayOf(PropTypes.shape({
    sa_field_name: PropTypes.string,
    sao_field_name: PropTypes.string
  })),
  saFields: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string
  })),
  allDucksReady: PropTypes.bool
};

SsatbFieldEditor.defaultProps = {
  dispatch: () => false,
  ssatbFields: [],
  saFields: [],
  allDucksReady: false
};


const mapDucksToProps = () => ({
  saFields: filterDuck(saFieldsDuck, { leaf_only: true, no_magical_fields: true }),
  ssatbFields: ssatbFieldsDuck
});

export default compose(
  duckify(mapDucksToProps)
)(SsatbFieldEditor);
